import React, { Component } from "react";
import { Select } from "antd";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

const Option = Select.Option;
/*Constants*/
export const ASSIGN_ME = "assignme";
export const UNASSIGN = "unassign";

class SearchSelect extends Component {
  // `Assign Me` should not open the dropdown. As a result we need an `open` state
  // to disable drop down.
  constructor(props) {
    super();
    this.state = {
      open: props.open,
      value: props.value,
      lineItemUUID: props.lineItemUUID,
      focus: props.focus // Lift the state up from the `Antd` component.
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { value, lineItemUUID } = nextProps;
    this.setState({ value, lineItemUUID, open: false });
  }

  componentDidMount() {
    // Override component.
    // Be very careful! This part will fail during
    // jest testing if it is not mount to the DOM.
    const node = ReactDOM.findDOMNode(this);
    if (node instanceof HTMLElement) {
      // Hide/show accordion when clicked
      const child = node.querySelector(".ant-select-arrow");
      child.addEventListener(
        "click",
        e => {
          e.stopImmediatePropagation();
          const { open } = this.state;
          this.setState({ open: !open }, () => {
            if (this.props.onSelectArrowClicked) {
              this.props.onSelectArrowClicked(!open);
            }
          });
        },
        false
      );
    }
  }

  onChange = value => {
    const { lineItemUUID, open } = this.state;
    if (!open && value !== ASSIGN_ME) {
      return;
    }

    const { userEmail, projectUUID } = this.props;
    if (value === ASSIGN_ME) {
      this.props.handleUserChange(userEmail, lineItemUUID, projectUUID);
    } else {
      this.props.handleUserChange(value, lineItemUUID, projectUUID);
    }
    this.setState({ open: false });
  };

  onFilterOptions = (input, { key, props }) => {
    const name = props.children[1].toLowerCase();
    const email = key.toLowerCase();
    return (
      name.indexOf(input.toLowerCase()) >= 0 ||
      email.indexOf(input.toLowerCase()) >= 0
    );
  };

  overrideOnSelect = v => {
    /*
      This is a must! When dropdown is open, the event will happen
      if this is override!
    */
    if (v === ASSIGN_ME) {
      this.onChange(v);
    }
  };

  overrideOnBlur = () => {
    this.setState({ focus: false, open: false });
  };

  overrideOnFocus = () => {
    this.setState({ focus: true });
  };

  overrideOnDropdownVisibleChange = isOpen => {
    if (isOpen === false) {
      return;
    }
    const { value } = this.state;
    /*
      If `Assign to Me` button is clicked
      then perform the logic which is to
      assign to self.
    */
    if (value === ASSIGN_ME) {
      this.onChange(value);
      this.setState({ open: false });
    }
  };

  render() {
    const { options, userEmail } = this.props;
    const { value, open } = this.state;

    const className =
      value === ASSIGN_ME ? "assign-user" : value ? "show-clear-icon" : "";
    const opt = options.map(opt => {
      return (
        <Option key={opt.email}>
          {value === opt.email && <i className="axiom-icon-icon icon-user" />}
          {opt.name}
        </Option>
      );
    });

    return (
      <Select
        value={value || ASSIGN_ME}
        showSearch={value !== ""}
        open={open}
        disabled={false}
        placeholder="Select a user"
        onChange={this.onChange}
        onDropdownVisibleChange={this.overrideOnDropdownVisibleChange}
        className={className}
        filterOption={this.onFilterOptions}
        style={{ width: "155px" }}
        onBlur={this.overrideOnBlur}
        onFocus={this.overrideOnFocus}
        onSelect={this.overrideOnSelect}
      >
        <Option key={UNASSIGN}>
          <i className="axiom-icon-icon icon-user-x error" />
          Unassign user
        </Option>
        {value !== userEmail && (
          <Option key={ASSIGN_ME}>
            <i className="axiom-icon-icon icon-user-plus" />
            Assign to Me
          </Option>
        )}
        {opt}
      </Select>
    );
  }
}

SearchSelect.propTypes = {
  open: PropTypes.bool,
  value: PropTypes.string,
  lineItemUUID: PropTypes.string,
  focus: PropTypes.bool, // Lift the state up from the `Antd` component.
  userEmail: PropTypes.string,
  projectUUID: PropTypes.string,
  options: PropTypes.array,
  handleUserChange: PropTypes.func,
  onSelectArrowClicked: PropTypes.func
};

SearchSelect.defaultProps = {
  open: false,
  focus: false,
  onSelectArrowClicked: val => {}
};

export default SearchSelect;
